import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/src/clients/ckclient/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/clients/ckclient/app/layouts/default.vue").then(m => m.default || m)),
  "full-with-mini-header": defineAsyncComponent(() => import("/src/clients/ckclient/app/layouts/fullWithMiniHeader.vue").then(m => m.default || m)),
  reporting: defineAsyncComponent(() => import("/src/clients/ckclient/app/layouts/reporting.vue").then(m => m.default || m))
}